import { createFileRoute } from "@tanstack/react-router";
import { ChevronDown } from "lucide-react";
import { useTranslation } from "react-i18next";
import FaqAnswer from "@/components/FaqAnswer";
import { FAQ_CATEGORIES } from "@/data/faq.data";

export const Route = createFileRoute("/_default/faq")({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation();

  return (
    <div className="container mx-auto max-w-4xl px-4 py-8">
      <h1 className="mb-8 text-3xl font-bold">{t("faq_title")}</h1>

      {FAQ_CATEGORIES.map(({ titleKey, questions }) => (
        <section key={titleKey} className="mb-10">
          <h2 className="mb-4 text-2xl font-semibold">{t(titleKey)}</h2>

          <div className="divide-neutral-60 border-neutral-60 divide-y border-y">
            {questions.map(({ questionKey, answerKey }) => (
              <details
                key={questionKey}
                data-test-id="faq-question"
                className="group py-4"
              >
                <summary className="flex cursor-pointer list-none items-center justify-between gap-4 font-medium [&::-webkit-details-marker]:hidden">
                  {t(questionKey)}
                  <ChevronDown className="text-neutral-30 size-5 shrink-0 transition-transform group-open:rotate-180" />
                </summary>
                <div data-test-id="faq-answer" className="mt-3 text-gray-300">
                  <FaqAnswer answerKey={answerKey} />
                </div>
              </details>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}
